/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelUserResponseModel } from '../../models/paged-model-user-response-model';

export interface ListUsers$Params {
  merchantId?: string;
}

export function listUsers(http: HttpClient, rootUrl: string, params?: ListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelUserResponseModel>> {
  const rb = new RequestBuilder(rootUrl, listUsers.PATH, 'get');
  if (params) {
    rb.query('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelUserResponseModel>;
    })
  );
}

listUsers.PATH = '/users';
